// El script se incluye en varias secciones y en el layout: solo debe correr una vez por página.
if (!window.__cnzCargado) {
window.__cnzCargado = true;
// Carta Namazzi: idioma ES/EN, índice que se arma solo con las secciones, encabezado que sigue la sección y movimiento suave.
// Estado abierto/cerrado del café según la hora de Medellín (inicio)
(function () {
  var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  function aHoras(v) { var p = String(v).split(/[:.]/); return (+p[0] || 0) + (+(p[1] || 0)) / 60; }
  function hora12(h) { var hh = Math.floor(h), mm = Math.round((h - hh) * 60), x = hh % 12 || 12; return x + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + (hh < 12 ? ' a. m.' : ' p. m.'); }
  document.querySelectorAll('[data-cnz-horario]').forEach(function (el) {
    var abre = aHoras(el.dataset.abre), cierra = aHoras(el.dataset.cierra);
    var abiertos = (el.dataset.dias || '').split(',').map(Number);
    var partes = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Bogota', hour: 'numeric', minute: 'numeric', weekday: 'short', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { partes[p.type] = p.value; });
    var dia = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(partes.weekday);
    var ahora = (+partes.hour % 24) + (+partes.minute) / 60;
    var texto, abierto = abiertos.indexOf(dia) > -1 && ahora >= abre && ahora < cierra;
    if (abierto) texto = 'Abierto ahora · hasta las ' + hora12(cierra);
    else {
      var d = dia, cuando = 'hoy';
      if (!(abiertos.indexOf(dia) > -1 && ahora < abre)) {
        for (var i = 1; i <= 7; i++) { d = (dia + i) % 7; if (abiertos.indexOf(d) > -1) break; }
        cuando = d === (dia + 1) % 7 ? 'mañana' : 'el ' + dias[d];
      }
      texto = 'Cerrado · abrimos ' + cuando + ' a las ' + hora12(abre);
    }
    el.classList.toggle('cerrado', !abierto);
    el.querySelector('span').textContent = texto;
  });
})();

(function () {
  var raiz = document.documentElement;
  var carta = document.querySelector('.cnz');
  if (!carta) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var actual = document.getElementById('cnz-sec-actual');
  var botones = [].slice.call(document.querySelectorAll('.cnz-idioma button'));
  var secs = [].slice.call(document.querySelectorAll('.cnz [data-es]'));
  var ultima = null;

  function lengua() { return raiz.classList.contains('cnz-en') ? 'en' : 'es'; }

  // Índice: una entrada por cada sección que tenga nombre de índice
  var indice = document.getElementById('cnz-indice');
  var enlaces = [];
  secs.forEach(function (s) {
    if (!s.dataset.indiceEs || !indice) return;
    var a = document.createElement('a');
    a.href = '#' + s.id;
    a.innerHTML = '<span lang="es"></span><span lang="en"></span>';
    a.children[0].textContent = s.dataset.indiceEs;
    a.children[1].textContent = s.dataset.indiceEn || s.dataset.indiceEs;
    indice.appendChild(a);
    enlaces.push({ a: a, s: s });
  });

  function idioma(l) {
    raiz.classList.toggle('cnz-en', l === 'en');
    botones.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.l === l ? 'true' : 'false'); });
    try { localStorage.setItem('nz-idioma', l); } catch (e) {}
    var s = ultima || secs[0];
    if (actual && s) actual.textContent = s.dataset[l];
  }
  botones.forEach(function (b) { b.addEventListener('click', function () { idioma(b.dataset.l); }); });
  var guardado = null;
  try { guardado = localStorage.getItem('nz-idioma'); } catch (e) {}
  // ?lang=en (o es) manda: lo usan el QR de la carta impresa y los enlaces del blog en inglés
  var pedido = (location.search.match(/[?&]lang=(es|en)\b/i) || [])[1];
  if (pedido) guardado = pedido.toLowerCase();
  // El idioma solo cambia en páginas con selector (la carta); el inicio y el pie van en español
  if (botones.length && (guardado === 'en' || (!guardado && !/^es/i.test(navigator.language || 'es')))) idioma('en');
  else if (botones.length && pedido) idioma('es');

  function poner(sec) {
    ultima = sec;
    var t = sec.dataset[lengua()];
    // el enlace activo es el de la última sección con índice que está antes o en la actual
    var activo = null;
    enlaces.forEach(function (e) {
      if (e.s === sec || (e.s.compareDocumentPosition(sec) & Node.DOCUMENT_POSITION_FOLLOWING)) activo = e;
    });
    enlaces.forEach(function (e) { e.a.setAttribute('aria-current', e === activo ? 'true' : 'false'); });
    // en celular la categoría activa se centra sola en la barra
    if (activo && indice && indice.scrollWidth > indice.clientWidth) {
      var x = activo.a.offsetLeft - indice.clientWidth / 2 + activo.a.offsetWidth / 2;
      indice.scrollTo({ left: Math.max(0, x), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (!actual || actual.textContent === t) return;
    if (reduce) { actual.textContent = t; return; }
    actual.classList.add('sale');
    setTimeout(function () {
      actual.textContent = t;
      actual.style.transition = 'none';
      actual.style.transform = 'translateY(100%)';
      actual.classList.remove('sale');
      requestAnimationFrame(function () { requestAnimationFrame(function () { actual.style.transition = ''; actual.style.transform = ''; }); });
    }, 220);
  }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) poner(e.target); }); }, { rootMargin: '-40% 0px -55% 0px' });
  secs.forEach(function (s) { io.observe(s); });

  // La barra se fija arriba al pasar la portada y se suelta al terminar la carta
  var barra = document.querySelector('.cnz-barra'), marca = document.querySelector('.cnz-barra-marca'), fin = document.querySelector('.cnz-fin');
  function revisar() {
    if (!barra || !marca) return;
    var alto = barra.offsetHeight;
    var fijo = marca.getBoundingClientRect().top < 0 && (!fin || fin.getBoundingClientRect().top > alto);
    if (fijo !== barra.classList.contains('fija')) {
      barra.classList.toggle('fija', fijo);
      marca.style.height = fijo ? alto + 'px' : '0px';
    }
  }
  addEventListener('scroll', revisar, { passive: true });
  addEventListener('resize', revisar);
  revisar();

  // La ficha de catación se abre sola en pantalla grande
  if (matchMedia('(min-width: 900px)').matches) document.querySelectorAll('.cnz-det').forEach(function (d) { d.open = true; });

  if (reduce) return;
  // Las olas se dibujan y las fotos se asientan al llegar (siempre visibles)
  var hist = document.querySelector('.cnz-historia');
  var io2 = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      if (e.target === hist) hist.classList.add('dibuja'); else e.target.classList.add('asienta');
      io2.unobserve(e.target);
    });
  }, { threshold: 0.15 });
  if (hist) io2.observe(hist);
  document.querySelectorAll('.cnz figure').forEach(function (f) { if (f.getBoundingClientRect().top > innerHeight) io2.observe(f); });
})();
}
